export default {
  MOULINSOUFFLET: 52,
  ORAPI: 56,
  BACKEUROP: 50,
  BACKEUROPGLOBAL: 50,
  BACKEUROPMEMBERS: 50,
  LELIEVRE: 50,
  BONNIN: 50,
  ARNAUD: 50,
  COGEFOB: 50,
  BRENDANI: 50,
  GOUGEON: 50,
  HULINE: 50,
  PROST: 50,
  DISSERT: 50,
  GRECIET: 50,
  SAPRIMEX: 86,
  DISTRISUD: 87,
  CARNIVORP: 86,
  CARNIVORN: 89,
};
